
import { Popover, Table, Image, Tag, Row, Col, Input, Select } from 'antd';
import React, { useState, useEffect } from 'react';
import { PlusOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { fetchData } from '../../httpRequests';
import moment from 'moment';
const { Search } = Input;

const form = {
    name: '',
    website: 'https://www.google.com',
    category_id: null,
    pharmacies_id: null,
    plan_id: null
}

export default function AdsPlansAdmin() {

    const [filteredAds, setFilteredAds] = useState([]);
    const [filteredAdsName, setFilteredAdsName] = useState([]);
    const [tbLoading, setTbLoading] = useState(false)
    const [fharmacies, setFharmacies] = useState([]);
    const [plans, setPlans] = useState([])
    const [categorys, setCategorys] = useState([]);
    const [formValues, setFormValues] = useState(form)
    const { website, name, category_id, pharmacies_id, plan_id } = formValues
    useEffect(() => {
        getAds()
        getFharmacies(),
            getPlans(),
            getCategoty()
    }, [])

    const getAds = () => {
        const id = localStorage.getItem('PHARMACY_LOGGED')
        const url = `/planAds/getPlanAdsAdmin`;
        fetchData(url).then((response) => {
            if (Object.keys(response).length > 0) {
                const planAds = response['planAds'];
                setFilteredAds(planAds)
                setFilteredAdsName(planAds)
            }
        })
    }

    const getFharmacies = () => {
        const url = '/pharmacies/getPharmacies';
        fetchData(url).then((response) => {
            if (Object.keys(response).length > 0) {
                const farmacies = response['pharmacy'];
                let allFarmcy = farmacies
                allFarmcy.unshift({ id: 0, name: 'All' })
                setFharmacies(allFarmcy)
            }
        })
    }
    const getPlans = () => {
        setTbLoading(true)
        const url = '/plans/getPlans';
        fetchData(url).then((response) => {
            if (Object.keys(response).length > 0) {
                const plans = response['plans'];
                let allPlans = plans
                allPlans.unshift({ id: 0, name: 'All' })
                setPlans(allPlans)
            }
        })
        setTbLoading(false)
    }

    const getCategoty = () => {
        const url = '/categories/getCategories';
        fetchData(url).then((response) => {
            if (Object.keys(response).length > 0) {
                const categories = response['category'];
                let allCategory = categories
                allCategory.unshift({ id: 0, name: 'Alll' })
                setCategorys(allCategory)
            }
        })
    }

    const handleFilterPhamacies = (e) => {
        setFormValues({
            ...formValues,
            pharmacies_id: e,
            plan_id: null,
            category_id: null,
            name: ''
        })

        if (e == 0) {
            getAds()
        } else {
            const filtetFarmacy = filteredAds.filter((ads) => {
                return ads.id_pharmacy == e
            })
            setFilteredAdsName(filtetFarmacy);
        }

    }

    const handleFilterPlan = (e) => {
        console.log(filteredAds)
        setFormValues({
            ...formValues,
            plan_id: e,
            pharmacies_id: null,
            category_id: null,
            name: ''
        })

        if (e == 0) {
            getAds()
        } else {
            const filterPlan = filteredAds.filter((plan) => {
                return plan.id_plans == e
            })

            setFilteredAdsName(filterPlan);
        }
    }

    const handleFilterCategory = (e) => {
        setFormValues({
            ...formValues,
            plan_id: null,
            pharmacies_id: null,
            name: '',
            category_id: e
        })

        if (e == 0) {
            getAds()
        } else {
            const filterCategorys = filteredAds.filter((category) => {
                return category.category_id == e
            })
            setFilteredAdsName(filterCategorys);
        }
    }

    const columns = [
        {
            title: 'ADS NAME ',
            render: ({ id, status, img, website, name_ads }) => (
                <div>
                    {name_ads}
                </div>
            )
        },
        {
            title: 'PHARMACIES',
            render: ({ name_pharmacy }) => (
                <div>
                    {name_pharmacy}
                </div>
            )
        },

        {
            title: 'IMG',
            render: ({ img }) => (
                <div
                    style={{
                        width: 40
                    }}
                >
                    <Image src={img} />
                </div>
            )
        },
        {
            title: 'PLANS',
            render: ({ plans_name }) => (
                <div>
                    {
                        (plans_name == null)
                            ? <div style={{ color: 'red' }}>
                                No seleted
                            </div>
                            : <div>
                                {plans_name}
                            </div>
                    }
                </div>
            )
        },
        {
            title: 'CATEGORIES',
            render: ({ name_category }) => (
                <div>
                    {name_category}
                </div>
            )
        },
        {
            title: 'PUBLICATION DATE',
            render: ({ id, status, img, website, publicationDate }) => (
                <div>
                    {
                        (publicationDate) ? <div> {moment(publicationDate)
                            .format("LLLL")
                        }</div> : <div style={{ color: 'red' }}>No seleted</div>
                    }

                </div>
            )
        },
        {
            title: 'PUBLICATION END DATE',
            render: ({ id, status, img, website, lastPublicationDate }) => (
                <div>
                    {
                        (lastPublicationDate) ? <div> {moment(lastPublicationDate)
                            .format("LLLL")
                        }</div> : <div style={{ color: 'red' }}>No seleted</div>
                    }

                </div>
            )
        },
        {
            title: 'STATUS',
            render: ({ status }) => (
                <div>
                    {status}
                    {
                        (status)
                            ?
                            <Tag color="green">Active</Tag>

                            : <Tag color="volcano" >Disabled</Tag>
                    }
                </div>
            )
        },
        // {
        //     title: 'ACTION',
        //     render: ({ id, img }) => (
        //         <div style={{ display: 'flex' }}>
        //             <Popover content={editAds} trigger="hover">
        //                 <span style={{ margin: 10, cursor: 'pointer' }}>
        //                     <EditOutlined style={{ fontSize: '25px', color: '#128780' }} />
        //                 </span>
        //             </Popover>

        //             <Popover content={deleteAds} trigger="hover">
        //                 <span style={{ margin: 10, cursor: 'pointer' }}  >
        //                     <DeleteOutlined style={{ fontSize: '25px', color: 'red' }} />
        //                 </span>
        //             </Popover>
        //         </div>
        //     )
        // },

    ]

    const onSearch = (value) => {
        let text = value.target.value.trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
        setFormValues({
            ...formValues,
            name: text,
            plan_id: null,
            pharmacies_id: null,
            category_id: null
        })

        if (text) {
            const filteredAdsName = filteredAds.filter((ads) => {
                return ads.name_ads.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim().includes(text.toLowerCase())
            });
            setFilteredAdsName(filteredAdsName);
        } else {
            setFilteredAdsName(filteredAds);
        }
    }

    return (
        <div>
            <Row gutter={24} style={{ marginBottom: '20px' }}>
                <Col span={6}>
                    <Search
                        size='large'
                        placeholder='Search name'
                        onChange={onSearch}
                        name="name"
                        value={name}
                    />
                </Col>
                <Col span={6}>
                    <Select
                        style={{ width: '100%' }}
                        size='large' name="pharmacies_id"
                        placeholder='Pharmacy'
                        value={pharmacies_id}
                        onChange={handleFilterPhamacies}
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                    >
                        {fharmacies.map((c) => (
                            <Select.Option key={c.id} value={c.id}  >
                                {c.name}
                            </Select.Option>
                        ))
                        }
                    </Select>
                </Col>
                <Col span={6}>
                    <Select
                        style={{ width: '100%' }}
                        size='large' name="plan_id"
                        value={plan_id}
                        onChange={handleFilterPlan}
                        placeholder='Plans'
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                    >
                        {plans.map((c) => (
                            <Select.Option key={c.id} value={c.id}  >
                                {c.name}
                            </Select.Option>
                        ))
                        }
                    </Select>
                </Col>

                <Col span={6}>
                    <Select style={{ width: '100%' }}
                        size='large'
                        name="category_id"
                        value={category_id}
                        onChange={handleFilterCategory}
                        placeholder='Categories'
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}

                    >
                        {categorys.map((c) => (
                            <Select.Option key={c.id} value={c.id}  >
                                {c.name}
                            </Select.Option>
                        ))
                        }
                    </Select>
                </Col>
            </Row>
            <Table columns={columns} dataSource={filteredAdsName} rowKey={(item) => item.id}
                loading={tbLoading} />
        </div>
    )

}